import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { SlidersHorizontal, X } from "lucide-react";

const ROOMS = ["1+0", "1+1", "2+1", "3+1", "4+1", "5+1"];

export const FilterPanel = ({ filters, setFilters, onClear, resultCount }) => {
  const upd = (k, v) => setFilters({ ...filters, [k]: v });

  return (
    <aside data-testid="filter-panel" className="bg-white border border-slate-200 rounded-2xl p-6 sticky top-24">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <SlidersHorizontal className="w-4 h-4 text-[#C0562F]" />
          <div className="font-display text-lg text-slate-900">Filtreler</div>
        </div>
        <button onClick={onClear} data-testid="filter-clear" className="text-xs text-slate-500 hover:text-[#C0562F] flex items-center gap-1"><X className="w-3 h-3" />Temizle</button>
      </div>

      <div className="space-y-5">
        <div>
          <label className="label-caps block mb-2">İşlem</label>
          <Select value={filters.transaction_type || "all"} onValueChange={(v) => upd("transaction_type", v === "all" ? "" : v)}>
            <SelectTrigger data-testid="filter-islem"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tümü</SelectItem>
              <SelectItem value="satilik">Satılık</SelectItem>
              <SelectItem value="kiralik">Kiralık</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="label-caps block mb-2">Tip</label>
          <Select value={filters.property_type || "all"} onValueChange={(v) => upd("property_type", v === "all" ? "" : v)}>
            <SelectTrigger data-testid="filter-tip"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tümü</SelectItem>
              <SelectItem value="daire">Daire</SelectItem>
              <SelectItem value="villa">Villa</SelectItem>
              <SelectItem value="arsa">Arsa</SelectItem>
              <SelectItem value="isyeri">İşyeri</SelectItem>
              <SelectItem value="diger">Diğer</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label-caps block mb-2">İl</label>
            <Input data-testid="filter-city" placeholder="Bursa" value={filters.city || ""} onChange={(e) => upd("city", e.target.value)} />
          </div>
          <div>
            <label className="label-caps block mb-2">İlçe</label>
            <Input data-testid="filter-district" placeholder="Nilüfer" value={filters.district || ""} onChange={(e) => upd("district", e.target.value)} />
          </div>
        </div>

        <div>
          <label className="label-caps block mb-2">Fiyat Aralığı (₺)</label>
          <div className="grid grid-cols-2 gap-3">
            <Input data-testid="filter-min-price" type="number" placeholder="Min" value={filters.min_price || ""} onChange={(e) => upd("min_price", e.target.value)} />
            <Input data-testid="filter-max-price" type="number" placeholder="Max" value={filters.max_price || ""} onChange={(e) => upd("max_price", e.target.value)} />
          </div>
        </div>

        <div>
          <label className="label-caps block mb-2">Alan (m²)</label>
          <div className="grid grid-cols-2 gap-3">
            <Input data-testid="filter-min-area" type="number" placeholder="Min" value={filters.min_area || ""} onChange={(e) => upd("min_area", e.target.value)} />
            <Input data-testid="filter-max-area" type="number" placeholder="Max" value={filters.max_area || ""} onChange={(e) => upd("max_area", e.target.value)} />
          </div>
        </div>

        <div>
          <label className="label-caps block mb-2">Oda Sayısı</label>
          <Select value={filters.room_count || "all"} onValueChange={(v) => upd("room_count", v === "all" ? "" : v)}>
            <SelectTrigger data-testid="filter-rooms"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Fark etmez</SelectItem>
              {ROOMS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {resultCount !== undefined && (
          <div className="pt-4 border-t border-slate-100 text-xs text-slate-500">
            <span className="font-semibold text-slate-900">{resultCount}</span> ilan bulundu
          </div>
        )}
      </div>
    </aside>
  );
};
